riot.tag2('bbc-notifications-onboarded-view', '<bbc-notifications-onboarding-u13-success if="{this.showU13Success}" main-app="{opts.mainApp}"></bbc-notifications-onboarding-u13-success> <div class="notifications-main notifications__container notifications-{this.view} notifications-{this.view}--js notifications-main--css notification-signed-in"> <bbc-notifications-home-view if="{this.view === \'home\'}" main-app="{opts.mainApp}" component-app="{opts.componentApp}" notifications="{opts.notifications}" reached-end="{opts.reachedEnd}" loading-more="{opts.loadingMore}"></bbc-notifications-home-view> <bbc-notifications-settings-view if="{this.view === \'settings\'}" main-app="{opts.mainApp}" component-app="{opts.componentApp}"></bbc-notifications-settings-view> </div>', '', '', function(opts) {
'use strict';

var _this = this;

var notificationsAnalytics = require('../analytics');

this.view = opts.view;

this.on('mount', function () {
    if (typeof localStorage !== 'undefined') {
        if (opts.state.signedIn && localStorage.getItem('bbc-notifications-u13-pending-policy')) {
            _this.update({ showU13Success: true });
            localStorage.removeItem('bbc-notifications-u13-pending-policy');
        }
    }
});

this.hideU13Success = function () {
    _this.update({ showU13Success: false });
};

this.openSettings = function () {
    notificationsAnalytics.log('click', 'notifications-settings');
    _this.update({ view: 'settings' });
    return false;
};

this.closeSettings = function () {
    _this.update({ view: 'home' });
    return false;
};

this.on('updated', function () {
    console.log('Onboarded view updated');
    opts.mainApp.updateDrawerHeight();
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications-onboarded-view.tag
 ** module id = 24
 ** module chunks = 0
 **/